import { GameStatus } from "../../models/GameStatus";
import { PlayerPublic } from "../../models/Player";
import store from "../../store/store";
import Player from "./Player";
import "./Player.scss"
import classNames from 'classnames';
import { useState } from "react";
import { playSound, Sounds } from "../../models/Sounds";

export default function Players() {
  const gameState = store.getState().game;
  const players = gameState.players;
  const player = gameState.player;

  const [lastPendingNotification, setLastPendingNotification] = useState<GameStatus | null>(null);

  const maxScore = Math.max.apply(Math, players.map((it) => it.score));
  let leaders = players.map(it => it.score === maxScore ? it.playerId : null).filter(it => it);
  if (leaders.length === players.length) {
    leaders = [];
  }

  function isPlayerPending(playerPublic: PlayerPublic | undefined, isClient: boolean = false) {

    if (!playerPublic) {
      return false;
    }

    switch (gameState.status) {
      case GameStatus.SENTENCE:
        return playerPublic.isStoryteller && !playerPublic.hasMatched;
      case GameStatus.MATCH:
        return !playerPublic.isStoryteller && !playerPublic.hasMatched;
      case GameStatus.VOTE:
        return !playerPublic.hasVoted;
      case GameStatus.TURN_RESULTS:
        return !playerPublic.hasFinished;
      default:
        return false;
    }
  }

  const pendingPlayers = players.filter(it => isPlayerPending(it));
  const clientPending = isPlayerPending(player?.data) && pendingPlayers.length === 1;

  if (
    clientPending
    && lastPendingNotification !== gameState.status
    && gameState.status !== GameStatus.SENTENCE // don't notify pending storyteller
  ) {
    playSound(Sounds.HMM);
    setLastPendingNotification(gameState.status);
  }


  return (
    <div className="players">
      {players.map((it) => {
        const isClient = player?.data.playerId === it.playerId;
        const isPending = isPlayerPending(it);
        const isLastPending = isClient && isPending && pendingPlayers.length === 1;
        const place = it?.place;

        const classes = classNames({
          'player_leading': leaders.includes(it.playerId),
        });
        return <Player
          classes={classes}
          player={it}
          key={it.playerId}
          size={46}
          isPending={isPending}
          isClient={isClient}
          isLastPending={isLastPending}
          place={place}
          emoji={it.emoji}
        />;
      })}
    </div>
  )
}